var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOggy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_397",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29247",
    "data-name": "Group 29247",
    transform: "translate(657 10837)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -657, -10837)",
    filter: "url(#Ellipse_397)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_397-2",
    "data-name": "Ellipse 397",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50207",
    "data-name": "Path 50207",
    d: "M8.093,17.389a.367.367,0,0,0,.057-.619c-1.756-1.345-3.632-1.839-4.877-1.323A7.84,7.84,0,0,1,7.7,17.354.361.361,0,0,0,8.093,17.389Z",
    transform: "translate(-639.994 -10826.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50208",
    "data-name": "Path 50208",
    d: "M7.976,20.308a.367.367,0,0,0-.274-.559,4.865,4.865,0,0,0-4.018,1.039,7.651,7.651,0,0,1,3.941-.309A.357.357,0,0,0,7.976,20.308Z",
    transform: "translate(-640.104 -10827.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50209",
    "data-name": "Path 50209",
    d: "M12.81,37.148c4.4-11.009-1.468-15.413-1.468-15.413S4.737,18.065,6.2,15.13s5.138-1.468,8.807,0C20.884,1.919,27.489,7.79,24.553,14.4c11.743-2.936,9.541,2.936,5.138,8.073s1.468,14.679,1.468,14.679Z",
    transform: "translate(-640.718 -10823.974)",
    fill: "#7bbed5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50210",
    "data-name": "Path 50210",
    d: "M31.185,2.564,28.6,6.3a2.557,2.557,0,0,0-1.411-.307l.952-3.24L25.482,6.576c-.124.073-.246.132-.373.219A1.667,1.667,0,0,1,25.423,8c1.593-1.077,4.1-.773,2.436,6.067a8.937,8.937,0,0,1,1.781-.906,6.316,6.316,0,0,0-.005-5.9Z",
    transform: "translate(-645.804 -10822.737)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50211",
    "data-name": "Path 50211",
    d: "M12.1,24.094l0-.015c7.668,1.809,12.824-.364,15.8-2.5,1.544-1.11,1.372-2.043.965-2.515l1.074-1c3.394,3.594-5.21,8.164-12.321,8.164a21.714,21.714,0,0,1-3.447-.255A5.3,5.3,0,0,0,12.1,24.094Z",
    transform: "translate(-642.343 -10826.86)",
    fill: "#70276e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_471",
    "data-name": "Ellipse 471",
    cx: 2.62,
    cy: 1.872,
    rx: 2.62,
    ry: 1.872,
    transform: "matrix(0.384, -0.923, 0.923, 0.384, -626.399, -10809.818)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_472",
    "data-name": "Ellipse 472",
    cx: 1.611,
    cy: 1.151,
    rx: 1.611,
    ry: 1.151,
    transform: "matrix(0.272, -0.962, 0.962, 0.272, -625.928, -10810.459)",
    fill: "#64dd17"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 0.699,
    cy: 0.589,
    rx: 0.699,
    ry: 0.589,
    transform: "translate(-625.631 -10811.696) rotate(-67.387)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50212",
    "data-name": "Path 50212",
    d: "M21.977,14.481a6.931,6.931,0,0,0-.906-.925,4.882,4.882,0,0,0-2.247-1.061c.577-1.241,1.735-1.937,2.65-1.557.948.394,1.27,1.79.717,3.118A3.39,3.39,0,0,1,21.977,14.481Z",
    transform: "translate(-644.132 -10824.938)",
    fill: "#7986cb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_474",
    "data-name": "Ellipse 474",
    cx: 2.757,
    cy: 1.969,
    rx: 2.757,
    ry: 1.969,
    transform: "translate(-624.187 -10808.94) rotate(-65.28)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_475",
    "data-name": "Ellipse 475",
    cx: 1.611,
    cy: 1.151,
    rx: 1.611,
    ry: 1.151,
    transform: "translate(-623.691 -10809.945) rotate(-67.387)",
    fill: "#64dd17"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_476",
    "data-name": "Ellipse 476",
    cx: 0.699,
    cy: 0.597,
    rx: 0.699,
    ry: 0.597,
    transform: "translate(-623.327 -10810.783) rotate(-67.387)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50213",
    "data-name": "Path 50213",
    d: "M25.55,15.537a4.449,4.449,0,0,0-3.706-1.748c.022-.054.036-.107.06-.16.667-1.449,2.046-2.236,3.081-1.76s1.333,2.037.666,3.485C25.622,15.419,25.583,15.475,25.55,15.537Z",
    transform: "translate(-644.935 -10825.176)",
    fill: "#7986cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50214",
    "data-name": "Path 50214",
    d: "M31.352,23.85l.3,3.069-2.4-2.01A16.423,16.423,0,0,0,31.352,23.85Z",
    transform: "translate(-646.908 -10828.4)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50215",
    "data-name": "Path 50215",
    d: "M17.849,27.084,16.982,29.7l-1.43-2.813A22.883,22.883,0,0,0,17.849,27.084Z",
    transform: "translate(-643.261 -10829.21)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28954",
    "data-name": "Group 28954",
    transform: "translate(-611.234 -10808.844)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_477",
    "data-name": "Ellipse 477",
    cx: 1.101,
    cy: 1.101,
    r: 1.101,
    transform: "translate(1.468)",
    fill: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_478",
    "data-name": "Ellipse 478",
    cx: 1.101,
    cy: 1.101,
    r: 1.101,
    transform: "translate(0 2.936)",
    fill: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50216",
    "data-name": "Path 50216",
    d: "M41.363,19.478a.367.367,0,0,1,.164-.6c2.117-.639,3.312-.441,4.3.48a5.7,5.7,0,0,0-4.084.222A.362.362,0,0,1,41.363,19.478Z",
    transform: "translate(-38.869 -18.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50217",
    "data-name": "Path 50217",
    d: "M39.351,23.328a.367.367,0,0,1,.31-.539,4.867,4.867,0,0,1,3.941,1.3,7.656,7.656,0,0,0-3.912-.571A.36.36,0,0,1,39.351,23.328Z",
    transform: "translate(-38.348 -19.273)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50218",
    "data-name": "Path 50218",
    d: "M17.392,16.454c-1.687-.949-3.865-1.757-5.165,0-.912,1.232.07,4.427,4.181,4.884,4.145.461,6.43-1.405,6.149-3.092S19.081,17.4,17.392,16.454Z",
    transform: "translate(-642.293 -10826.157)",
    fill: "#cd2616"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOggy);
export default __webpack_public_path__ + "static/media/oggy.f6c0f2ef5c88032997ac31631cc0f138.svg";
export { ForwardRef as ReactComponent };